import { captureException } from '@sentry/browser';
import { useEffect, useState } from 'react';
import { useDCS } from 'src/hooks/useDCS';
import { fetchAllProducts } from 'src/services/dcs/bundle';

export function useProductPricingInternal() {
  const [productIds, setProductIds] = useState<string[]>([]);
  const { productsPricings } = useDCS({ productIds });

  useEffect(() => {
    const fetchProductIds = async () => {
      const { data: products } = await fetchAllProducts();
      const productIdsCollected = products
        .map(x => x.id)
        .filter(s => !!s);
      setProductIds(productIdsCollected);
    };

    try {
      fetchProductIds();
    } catch (error) {
      console.error(error);
      captureException('Failed to fetch DCS Products');
    }

  }, []);

  return { productPricings: productsPricings };
}

export type ProductPricingContext = ReturnType<typeof useProductPricingInternal>;
